import qiniuUpload from './qiniuUpload.js'
import auth from './auth.js'

export default {
  ...qiniuUpload,
  ...auth
}
